import React from 'react';
import { Mail, Phone, ArrowUp } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const quickLinks = [
    { href: '#inicio', label: 'Inicio' },
    { href: '#nosotros', label: 'Acerca de Nosotros' },
    { href: '#servicios', label: 'Servicios' },
    { href: '#contacto', label: 'Contáctenos' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="container mx-auto px-6">
        {/* Main footer content */}
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company info */}
          <div className="lg:col-span-2">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-14 w-auto object-contain mb-6"
            />
            <p className="text-slate-400 mb-6 max-w-md leading-relaxed">
              Soluciones profesionales en soporte IT con más de 25 años de experiencia. 
              Especialistas en Networking, Windows Server y Soporte a usuarios de escritorio.
            </p>
            <div className="flex items-center gap-6">
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-2 text-slate-400 hover:text-orange-400 transition-colors"
              >
                <Mail size={18} />
                <span className="text-sm">{companyInfo.email}</span>
              </a>
            </div>
            <div className="mt-3">
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center gap-2 text-slate-400 hover:text-orange-400 transition-colors"
              >
                <Phone size={18} />
                <span className="text-sm">{companyInfo.phone}</span>
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-slate-400 hover:text-orange-400 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6">Servicios</h4>
            <ul className="space-y-3">
              <li><span className="text-slate-400 text-sm">Networking</span></li>
              <li><span className="text-slate-400 text-sm">Windows Server</span></li>
              <li><span className="text-slate-400 text-sm">Soporte de Escritorio</span></li>
              <li><span className="text-slate-400 text-sm">Contratos de Soporte</span></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="py-6 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm text-center md:text-left">
            © {new Date().getFullYear()} {companyInfo.name}. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-slate-500 text-sm">Socios certificados de Microsoft® y HP®</span>
          </div>
          <button
            onClick={scrollToTop}
            className="w-10 h-10 bg-slate-800 hover:bg-orange-500 border border-slate-700 hover:border-orange-500 rounded-lg flex items-center justify-center text-slate-400 hover:text-white transition-all duration-300"
            aria-label="Volver arriba"
          >
            <ArrowUp size={18} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
